import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { IBaseDisbursementType } from '../IBaseDisbursementType';
import { defaultCreate } from '../defaultCreate';
import { CheckDisbursementContainer } from './CheckDisbursementContainer';
import { CheckStatusPill } from './CheckStatusPill';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { defaultCheckMemo } from '../defaultMemo';

export interface ICheckDisbursementType extends IBaseDisbursementType<eDisbursementType.Check> { }

export const CheckDisbursementType: ICheckDisbursementType = {
  type: eDisbursementType.Check,

  editPermission: ePermissions.EscrowManualCheckDisbursementsEdit,
  readPermission: ePermissions.EscrowManualCheckDisbursementsRead,

  create: (fee, order, isSpruceWithZillowEnabled, isZillowClosing) => {
    const { beneficiary, ...defaultValues } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    return {
      type: eDisbursementType.Check,
      checkNumber: '',
      mailingAddress: {
        city: '',
        streetAddress: '',
        stateAbbreviation: '',
        zipCode: '',
      },
      ...defaultValues,
      memo: defaultCheckMemo(order),
      name: beneficiary,
      holdback: false,
      holdbackProperties: {},
    };
  },
  container: CheckDisbursementContainer,
  statusPill: CheckStatusPill,
  isReadOnly: (x) => {
    if (x.type === eDisbursementType.Check) {
      return !!x.completedAt || !!x.completedAtDate || !!x.voidedAt || !!x.sentAt || !!x.sentAtDate || !!x.printedDate;
    }
    return true;
  },
};
